<style lang="scss" scoped>
#TimelineChart {
  margin-top: 15px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  overflow: none;
}
.box {
  height: 35px;
  div {
    height: 100%;
  }
  &:first-of-type {
    .sGreen, .sRed {
      border-radius: 0 10px 10px 0;
    }
  }
  &:last-of-type {
    .sGreen, .sRed {
      border-radius: 10px 0 0 10px;
    }
  }
  .sGreen {
    background-color: #42b242;
    &:hover{
      background-color: #72cc72;
    }
  }
  .sRed {
    background-color: #e25e6a;
    &:hover{
      background-color: #e09fa5;
    }
  }
}
</style>

<template>

  <v-layout row column class="px-1 py-2">

    <v-flex xs12>
      <h3 class="text-xs-center">{{title}}</h3>
    </v-flex>

    <v-flex xs12>
      <v-layout row nowrap id="TimelineChart">
        <template v-for="(elem, index) in data">
          <v-tooltip v-if="elem && elem.length > 0" bottom open-delay="50" close-delay="20">
            <template v-slot:activator="{ on }">
              <v-flex v-for="(e, i) in elem" :key="index+'-'+i" class="box" grow v-on="on">
                <div :class="color"></div>
              </v-flex>
            </template>
            <span>{{fixFullTime(elem[0])}} - {{fixFullTime(elem[elem.length - 1])}}</span>
          </v-tooltip>
          <v-flex v-if="!elem" class="box" grow>
            <div class=""></div>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>

    <v-layout row nowrap class="TimelineTimes">
      <v-flex v-for="(elem, index) in times" :key="index" class="box" :class="elem ? 'shrink' : 'grow'">
        <div v-if="elem">{{elem}}</div>
      </v-flex>
    </v-layout>

  </v-layout>

</template>

<script>

import * as moment from 'moment';
const chunk = (arr, size) =>
  arr
  .reduce((acc, _, i) =>
    (i % size) ?
    acc :
    [...acc, arr.slice(i, i + size)], []);

export default {
  name: "LineChart",
  props: ['time', 'role', 'chartData'],
  data() {
    return {
      locale: Lang.get(),
      title: '',
    }
  },
  computed: {
    color() {
      return this.role == 0 ? 'sRed' : 'sGreen'
    },
    data() {
      let data = this.chartData;
      let arr = [];
      let last = false;
      for (let d in data) {
        if (data[d].status == 1 && !last) {
          arr.push([data[d].created_at]);
          last = true;
        }
        if (data[d].status == 1 && last) {
          arr[arr.length -1].push(data[d].created_at)
        }
        if (data[d].status == 0) {
          arr.push(null)
          last = false
        }
      }
      return arr;
    },
    times() {
      let length = this.chartData.length
      let Arr = [];
      if (this.time === 'day') {
        Arr = [this.fixMedTime(this.chartData[0].created_at)]
      } else if (this.time === 'week' || this.time === 'month') {
        Arr = [this.fixBigTime(this.chartData[0].created_at)]
      } else {
        Arr = [this.fixFullTime(this.chartData[0].created_at)]
      }
      let firstFill = Math.floor((length - 3) / 2)
      for (let i = 0; i < firstFill; i++) {
        Arr.push(null)
      }
      if (this.$vuetify.breakpoint.smAndUp) {
        if (this.time === 'day') {
          Arr.push(this.fixMedTime(this.chartData[firstFill].created_at))
        } else if (this.time === 'week' || this.time === 'month') {
          Arr.push(this.fixBigTime(this.chartData[firstFill].created_at))
        } else {
          Arr.push(this.fixFullTime(this.chartData[firstFill].created_at))
        }
      } else {
        Arr.push(null)
      }
      let secondFill = Math.ceil((length - 3) / 2)
      for (let i = 0; i < firstFill; i++) {
        Arr.push(null)
      }
      if (this.time === 'day') {
        Arr.push(this.fixMinTime(this.chartData[length - 1].created_at))
      } else if (this.time === 'week' || this.time === 'month') {
        Arr.push(this.fixMedTime(this.chartData[length - 1].created_at))
      } else {
        Arr.push(this.fixFullTime(this.chartData[length - 1].created_at))
      }
      return Arr;
    }
  },
  watch: {
    chartData(){
      this.setData();
    }
  },
  mounted() {
    if (this.locale == "he") {
      this.title = 'סטטוס'
    } else {
      this.title = 'Status'
    }
  },

  methods: {
    fixMinTime(time){
      return moment(time * 1000).format('LT')
    },
    fixMedTime(time){
      return moment(time * 1000).format('MMM Do, HH:mm')
    },
    fixBigTime(time){
      return moment(time * 1000).format('MMM Do, dddd, HH:mm')
    },
    fixFullTime(time){
      return moment(time * 1000).format('MMM Do, YYYY, HH:mm')
    },
    fixTime(time){
      return moment(time * 1000).format('llll')
    },
  }

}

</script>
